// Add your JS customizations here

(function ($) {
	class ProjetsEnCours {
		constructor() {
			this.initiateNavigation();
		}
		initiateNavigation() {
			const allProjets = $('.projet-en-cours-short');
			allProjets.on('click', function(event) {
				event.preventDefault();	

				allProjets.removeClass("selected");
				$( this ).addClass("selected");
				
				const post_id = $(this).data("post_id");				
				
				$.ajax({
					url: '/wp-admin/admin-ajax.php',
					type: 'get',
					data: {
						action: 'fetch_projets',
						post_id: post_id
					},
					success: function( res ) {						
						// TODO: Check the result
						const data = res.data;
						const default_message = "Description indisponible";
						const projet_detailed = $("#projet-en-cours-detailed");
						if (data == "Post not found!") {
							projet_detailed.html(default_message);
						} else {
							projet_detailed.html(res.data);
						}																
					}
				})

			});
		}
	}

	
	new ProjetsEnCours();

})(jQuery);

